import React from 'react';

interface TimerProps {
  timeLeft: number;
  maxTime: number;
}

const Timer: React.FC<TimerProps> = ({ timeLeft, maxTime }) => {
  const percentage = (timeLeft / maxTime) * 100;
  const isWarning = timeLeft <= 2;

  return (
    <div className="timer-container">
      <div className="timer-bar-bg">
        <div
          className={`timer-bar ${isWarning ? 'timer-warning' : ''}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <div className={`timer-text ${isWarning ? 'timer-text-warning' : ''}`}>
        {timeLeft}s
      </div>
    </div>
  );
};

export default Timer;
